<mat-card>{{'directChargeOrders' | translate}}</mat-card>



<div class="container" style="padding: 25px;">


    <mat-grid-list cols="6" rowHeight="50px">

        <mat-grid-tile colspan="2">
            <mat-form-field appearance="standard" class="example-form-field" style="margin: 10px;;">
                <mat-label>{{'status' | translate}}</mat-label>
                <mat-select [(value)]="selectedStatus" (selectionChange)="getDirectCharge()">
                    <mat-option *ngFor="let item of chargedStatus" [value]="item.id">
                        {{item.name | translate}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </mat-grid-tile>

        <mat-grid-tile colspan="2">
            <mat-form-field appearance="standard">
                <mat-label>{{'user' | translate}}</mat-label>
                <input type="text" matInput [formControl]="userControl" [matAutocomplete]="auto">
                <button mat-button matSuffix mat-icon-button>
                    <mat-icon>keyboard_arrow_down</mat-icon>
                </button>
                <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn"
                    (optionSelected)="selectUserChange($event.option.value)">
                    <mat-option *ngFor="let item of filteredOptions | async" [value]="item">
                        {{item.userName}}
                        {{item.userName != null && item.fullName != null ? '-' : ""}}
                        {{item.fullName}}
                    </mat-option>
                </mat-autocomplete>
                <button type="button" mat-button *ngIf="selectedUserId != ''" matSuffix mat-icon-button
                    aria-label="Clear" (click)="clearUser()">
                    <mat-icon>close</mat-icon>
                </button>
                <mat-error *ngIf="userControl.invalid">{{'requiredField' | translate}}</mat-error>
            </mat-form-field>
        </mat-grid-tile>

        <mat-grid-tile colspan="2">
            <mat-form-field appearance="standard" class="example-form-field">
                <mat-label>{{'enterDateRange' | translate}}</mat-label>
                <mat-date-range-input [rangePicker]="rangePicker">
                    <input matStartDate placeholder="Start date" #fromDate>
                    <input matEndDate placeholder="End date" #toDate>
                </mat-date-range-input>
                <mat-datepicker-toggle matSuffix [for]="rangePicker"></mat-datepicker-toggle>
                <mat-date-range-picker #rangePicker>
                    <mat-date-range-picker-actions>
                        <button mat-button matDateRangePickerCancel>{{'cancel' | translate}}</button>
                        <button mat-raised-button color="primary" matDateRangePickerApply>{{'ok'
                            |
                            translate}}</button>
                    </mat-date-range-picker-actions>
                </mat-date-range-picker>
            </mat-form-field>
        </mat-grid-tile>

        <mat-grid-tile colspan="2">
            <mat-form-field appearance="standard">
                <mat-label>{{'filter' | translate}}</mat-label>
                <input matInput (keyup)="applyFilter($event)" placeholder="Ex. Mia" #input>
            </mat-form-field>
        </mat-grid-tile>

        <mat-grid-tile colspan="2">
            <mat-checkbox class="example-margin" [(ngModel)]="apiOrders">
                API
            </mat-checkbox>
        </mat-grid-tile>

        <mat-grid-tile colspan="2">
            <button mat-raised-button color="primary" (click)="onSearch()" style="margin-left: 10px;">
                <mat-icon>search</mat-icon>
                {{'filter' | translate}}
            </button>
        </mat-grid-tile>

    </mat-grid-list>

    <div class="mat-elevation-z8">
        <table mat-table [dataSource]="dataSource" matSort>

            <ng-container matColumnDef="orderId">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'orderNo' | translate}} </th>
                <td mat-cell *matCellDef="let row"> {{row.orderId}} </td>
            </ng-container>

            <ng-container matColumnDef="date">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'dateTime' | translate}} </th>
                <td mat-cell *matCellDef="let row"> {{row.dateTime}} </td>
            </ng-container>

            <ng-container matColumnDef="userFullName">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'fullName' | translate}} </th>
                <td mat-cell *matCellDef="let row"> {{row.userFullName}} </td>
            </ng-container>

            <ng-container matColumnDef="product">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'product' | translate}} </th>
                <td mat-cell *matCellDef="let row"> {{row.product}} </td>
            </ng-container>

            <ng-container ntainer matColumnDef="quantity">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'quantity' | translate}} </th>
                <td mat-cell *matCellDef="let row"> {{row.quantity}} </td>
            </ng-container>

            <ng-container ntainer matColumnDef="playerId">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'playerId' | translate}} </th>
                <td mat-cell *matCellDef="let row">

                    <button mat-stroked-button color="primary" (click)="copyPlayerId(row.playerId)"
                        *ngIf="row.playerId != '' && row.playerId != null">{{row.playerId}}</button>
                    <br *ngIf="row.userName != '' && row.userName != null" />

                    <button mat-stroked-button color="primary" (click)="copyPlayerId(row.userName)"
                        *ngIf="row.userName != '' && row.userName != null">{{row.userName}}</button>
                    <br *ngIf="row.playerName != '' && row.playerName != null" />
                    <button mat-stroked-button color="primary" (click)="copyPlayerId(row.playerName)"
                        *ngIf="row.playerName != '' && row.playerName != null">{{row.playerName}}</button>
                    <br *ngIf="row.phoneNumber != '' && row.phoneNumber != null" />
                    <button mat-stroked-button color="primary" (click)="copyPlayerId(row.phoneNumber)"
                        *ngIf="row.phoneNumber != '' && row.phoneNumber != null">{{row.phoneNumber}}</button>
                    <br *ngIf="row.password != '' && row.password != null" />
                    <button mat-stroked-button color="primary" (click)="copyPlayerId(row.password)"
                        *ngIf="row.password != '' && row.password != null">{{row.password}}</button>
                    <br *ngIf="row.email != '' && row.email != null" />
                    <button mat-stroked-button color="primary" (click)="copyPlayerId(row.email)"
                        *ngIf="row.email != '' && row.email != null">{{row.email}}</button>
                    <br *ngIf="row.CardNumber != '' && row.CardNumber != null" />
                    <button mat-stroked-button color="primary" (click)="copyPlayerId(row.cardNumber)"
                        *ngIf="row.cardNumber != '' && row.cardNumber != null">{{row.cardNumber}}</button>
                    <br *ngIf="row.busCardNumber != '' && row.busCardNumber != null" />
                    <button mat-stroked-button color="primary" (click)="copyPlayerId(row.busCardNumber)"
                        *ngIf="row.busCardNumber != '' && row.busCardNumber != null">{{row.busCardNumber}}</button>
                </td>
            </ng-container>

            <ng-container ntainer matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'name' | translate}} </th>
                <td mat-cell *matCellDef="let row"> {{row.name}} </td>
            </ng-container>

            <ng-container ntainer matColumnDef="cardCode">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'cardNo' | translate}} </th>
                <td mat-cell *matCellDef="let row">
                    <button mat-stroked-button color="primary" (click)="copyPlayerId(row.cardCode)"
                        *ngIf="row.cardCode != ''">{{row.cardCode}}</button>
                </td>
            </ng-container>

            <ng-container matColumnDef="imageUrl">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'image' | translate}} </th>
                <td mat-cell *matCellDef="let row">
                    <img src="{{row.imageUrl}}" alt="no image" width="80" style="cursor: pointer;"
                        (click)="viewImg(row.imageUrl)">
                </td>
            </ng-container>

            <ng-container ntainer matColumnDef="notes">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'notes' | translate}} </th>
                <td mat-cell *matCellDef="let row"> {{row.notes}} </td>
            </ng-container>

            <ng-container matColumnDef="view">
                <th mat-header-cell *matHeaderCellDef> {{'view' | translate}} </th>
                <td mat-cell *matCellDef="let row">
                    <button mat-icon-button (click)="edit(row)">
                        <mat-icon>pageview</mat-icon>
                    </button>
                </td>
            </ng-container>

            <ng-container matColumnDef="action">
                <th mat-header-cell *matHeaderCellDef style="width: 10%;"> {{'chargedDone' | translate}} </th>
                <td mat-cell *matCellDef="let row;let i = index;" style="width: 10%;padding: 10px;">
                    <button mat-raised-button color="primary" style="margin-bottom: 10px;background-color: green;"
                        *ngIf="row.status == 0" (click)="onChargedDone(row)">
                        <mat-icon>save</mat-icon>
                        {{'chargedDone' | translate}}
                    </button>

                    <button mat-raised-button color="primary" (click)="onReject(row)" *ngIf="row.status == 0">
                        <mat-icon>call_missed</mat-icon>
                        {{'reject' | translate}}
                    </button>

                    <!-- <button mat-raised-button color="primary" (click)="viewInfo(row)">
                        <mat-icon>info</mat-icon>
                        معلومات
                    </button> -->

                </td>
            </ng-container>

            <!-- <ng-container matColumnDef="reject" *ngIf="selectedMessageType != 2">
                <th mat-header-cell *matHeaderCellDef style="width: 10%;"> {{'reject' | translate}} </th>
                <td mat-cell *matCellDef="let row;let i = index;" style="width: 10%;padding: 10px;">
                 
                </td>
            </ng-container> -->

            <!-- <ng-container matColumnDef="delete">
                <th mat-header-cell *matHeaderCellDef> {{'delete' | translate}} </th>
                <td mat-cell *matCellDef="let row">
                    <button mat-icon-button (click)="onDelete(row.id)">
                        <mat-icon>delete</mat-icon>
                    </button>
                </td>
            </ng-container> -->


            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

            <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell" colspan="4">{{'noDataMatchingTheFilter' | translate}}</td>
            </tr>
        </table>

        <mat-paginator [pageSize]="pageSize" [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator>
    </div>

</div>

<app-matspinner dir="rtl" [overlay]="spinnerOverlay"></app-matspinner>

<ng-template #Modal>

    <h1 mat-dialog-title>{{'confirm' | translate}}</h1>
    <div mat-dialog-content>
        <p>{{'areYouSureToDelete' | translate}}</p>

    </div>
    <div mat-dialog-actions>
        <button mat-button (click)="onNoClick()">{{'cancel' | translate}}</button>
        <button mat-button cdkFocusInitial>{{'yes' | translate}}</button>
    </div>

</ng-template>

<ng-template #ModalView>

    <h1 mat-dialog-title>{{'messageText' | translate}}</h1>
    <div mat-dialog-content>
        <!-- {{message_text}} -->
    </div>
    <div mat-dialog-actions>
        <button mat-button mat-dialog-close (click)="onNoClick()">Close</button>
    </div>

</ng-template>

<ng-template #ModalViewImg>

    <!-- <h1 mat-dialog-title>{{'messageText' | translate}}</h1> -->
    <div mat-dialog-content>
        <img src="{{imgView}}" alt="no image" width="100%" height="100%">
    </div>
    <div mat-dialog-actions>
        <button mat-button mat-dialog-close (click)="onNoClick()">Close</button>
    </div>

</ng-template>


<ng-template #ModalConfirmReject>

    <h1 mat-dialog-title>{{'confirm' | translate}}</h1>
    <div mat-dialog-content>
        <p>{{'areYouSureToReject' | translate}}</p>
        <mat-form-field appearance="standard">
            <mat-label>{{'rejectReason' | translate}}</mat-label>
            <textarea matInput [(ngModel)]="rejectReason"></textarea>
        </mat-form-field>
    </div>
    <div mat-dialog-actions>
        <button mat-button (click)="onNoClick()">{{'cancel' | translate}}</button>
        <button mat-button cdkFocusInitial (click)="confirmReject()">{{'yes' | translate}}</button>
    </div>

</ng-template>

<ng-template #ModalViewInfo>

    <h1 mat-dialog-title>{{'confirm' | translate}}</h1>
    <div mat-dialog-content>

        <mat-form-field appearance="standard" *ngIf="directCharge.userName != '' and directCharge.userName != null">
            <mat-label>اسم المستخدم</mat-label>
            <input matInput [(ngModel)]="directCharge.userName" readonly>
        </mat-form-field>

        <mat-form-field appearance="standard" *ngIf="directCharge.password != '' and directCharge.password != null">
            <mat-label> الباسوورد</mat-label>
            <input matInput [(ngModel)]="directCharge.password" readonly>
        </mat-form-field>

        <mat-form-field appearance="standard" *ngIf="directCharge.email != '' and directCharge.email != ''">
            <mat-label>الايميل</mat-label>
            <input matInput [(ngModel)]="directCharge.email" readonly>
        </mat-form-field>

        <mat-form-field appearance="standard"
            *ngIf="directCharge.phoneNumber != '' and directCharge.phoneNumber != null">
            <mat-label>رقم الهاتف</mat-label>
            <input matInput [(ngModel)]="directCharge.phoneNumber" readonly>
        </mat-form-field>

        <mat-form-field appearance="standard"
            *ngIf="directCharge.busCardNumber != '' and directCharge.busCardNumber != null">
            <mat-label>رقم بطاقة الباص السريع</mat-label>
            <input matInput [(ngModel)]="directCharge.busCardNumber" readonly>
        </mat-form-field>

        <mat-form-field appearance="standard" *ngIf="directCharge.cardNumber != '' and directCharge.cardNumber != null">
            <mat-label>رقم البطاقة</mat-label>
            <input matInput [(ngModel)]="directCharge.cardNumber" readonly>
        </mat-form-field>

        <mat-form-field appearance="standard" *ngIf="directCharge.playerName != '' and directCharge.playerName != null">
            <mat-label>اسم اللاعب</mat-label>
            <input matInput [(ngModel)]="directCharge.playerName" readonly>
        </mat-form-field>

    </div>
    <div mat-dialog-actions>
        <button mat-button (click)="onNoClick()">{{'cancel' | translate}}</button>
        <!-- <button mat-button cdkFocusInitial (click)="confirmReject()">{{'yes' | translate}}</button> -->
    </div>

</ng-template>